import { useRef } from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface CancelSigningDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
}

export const CancelSigningDialog = ({
  isOpen,
  onClose,
  onConfirm,
  isSubmitting,
}: CancelSigningDialogProps) => {
  const { t } = useTranslation();
  const dismissRef = useRef<HTMLButtonElement>(null);

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={dismissRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {t("Cancel signing?")}
          </AlertDialogHeader>
          <AlertDialogBody>
            {t("Confirm cancel signing description")}
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button ref={dismissRef} onClick={onClose}>
              {t("Keep signing")}
            </Button>
            <Button
              colorScheme="red"
              onClick={onConfirm}
              ml={3}
              isLoading={isSubmitting}
            >
              {t("Confirm cancel")}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
